const NOTIFICATION_CONSTANTS = {
    TYPES:[
        {label: 'Info', value: 'Info'},
        {label: 'Warning', value: 'Warning'},
        {label: 'Error', value: 'Error'},
        {label: 'Maintenance', value: 'Maintenance'}
],
    TYPE_MAINTENANCE: "Maintenance"
}

export default NOTIFICATION_CONSTANTS;